define(['text!./templates/yes-no-group.html'],
    (templateStr)=> {
        return [()=> {
            return {
                restrict: 'AE',
                template: templateStr,
                scope: {
                    label: '@',
                    model: '=',
                    helpTip : '@'
                }
            };
        }];
    }
);



/** WEBPACK FOOTER **
 ** ./common/js/src/edge/platform/widgets/inputs/YesNoGroup.js
 **/